import { validationValue } from "@/utils/validationValue";
import { Box, Flex, Img, Radio, RadioProps, Text } from "@chakra-ui/react";

interface PartnerProps extends RadioProps {
  cnpj: string;
  name: string;
  image: string;
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  phone1: string;
  phone2: string;
  cellphone: string;
  runflat: boolean;
  blindado: boolean;
  priceCarMounting: string;
  priceCarAlignment: string;
  priceCarBalancing: string;
  priceCarValve: string;
  priceCarCaster: string;
  priceCarCamber: string;
  priceCarRunflat?: string;
  priceCarBlindado?: string;
  priceUtilityMounting: string;
  priceUtilityAlignment: string;
  priceUtilityBalancing: string;
  priceUtilityValve: string;
  priceUtilityCaster: string;
  priceUtilityCamber: string;
  priceUtilityRunflat?: string;
  priceUtilityBlindado?: string;
}

export function CardPartnersDesktop({
  cnpj,
  name,
  image,
  street,
  number,
  district,
  city,
  state,
  phone1,
  phone2,
  cellphone,
  runflat,
  blindado,
  priceCarMounting,
  priceCarAlignment,
  priceCarBalancing,
  priceCarValve,
  priceCarCaster,
  priceCarCamber,
  priceCarRunflat,
  priceCarBlindado,
  priceUtilityMounting,
  priceUtilityAlignment,
  priceUtilityBalancing,
  priceUtilityValve,
  priceUtilityCaster,
  priceUtilityCamber,
  priceUtilityRunflat,
  priceUtilityBlindado,
  ...rest
}: PartnerProps) {
  return (
    <Radio {...rest} size="lg">
      <Flex
        alignItems="center"
        transition="all ease .3s"
        py="10px"
        px="10px"
        _hover={{ bgColor: "rgba(0, 0, 0, 0.15)" }}
        w={{ xl: "880px", "2xl": "930px" }}
      >
        <Box minW="170px" maxW="170px" minH="120px">
          <Img src={image} alt="Card" w="full" h="full" />
        </Box>

        <Flex ml="1rem" direction="column" w="320px">
          <Text textStyle="Bold" lineHeight="1.2rem">
            {name}
          </Text>
          <Text fontSize="text1" color="blue.900">
            3,2 Km distante do seu endereço
          </Text>
          <Text fontSize="text1">
            Rua {street}, {number}
            <br />
            {district} - {city} - {state}
          </Text>
          <Text fontSize="text1">
            {phone2
              ? cellphone
                ? `${phone1} - ${phone2} - ${cellphone}`
                : `${phone1} - ${phone2}`
              : phone1}
          </Text>
        </Flex>
        <Flex mr="60px" direction="column" alignItems="right" w="180px">
          <Text fontSize="text3">Montagem (por roda)</Text>
          <Text fontSize="text3">Alinhamento</Text>
          <Text fontSize="text3">Balaceamento (por roda)</Text>
          <Text fontSize="text3">Válvula (unidade)</Text>
          <Text fontSize="text3">Cáster</Text>
          <Text fontSize="text3">Cabagem</Text>
          {runflat && <Text fontSize="text3">Montagem (por roda) Runflat</Text>}
          {blindado && <Text fontSize="text3">Montagem (por roda) Blindado</Text>}
        </Flex>
        <Flex direction="column" mr="35px" w="60px">
          <Text fontSize="text3" color={validationValue(priceCarMounting) && "blue.900"}>
            {priceCarMounting}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarAlignment) && "blue.900"}>
            {priceCarAlignment}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarBalancing) && "blue.900"}>
            {priceCarBalancing}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarValve) && "blue.900"}>
            {priceCarValve}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarCaster) && "blue.900"}>
            {priceCarCaster}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarCamber) && "blue.900"}>
            {priceCarCamber}
          </Text>
          {runflat && (
            <Text fontSize="text3" color={validationValue(priceCarRunflat) && "blue.900"}>
              {" "}
              {priceCarRunflat}
            </Text>
          )}
          {blindado && (
            <Text fontSize="text3" color={validationValue(priceCarBlindado) && "blue.900"}>
              {" "}
              {priceCarBlindado}
            </Text>
          )}
        </Flex>
        <Flex direction="column" w="60px">
          <Text fontSize="text3" color={validationValue(priceCarMounting) && "blue.900"}>
            {" "}
            {priceUtilityMounting}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarAlignment) && "blue.900"}>
            {" "}
            {priceUtilityAlignment}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarBalancing) && "blue.900"}>
            {" "}
            {priceUtilityBalancing}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarValve) && "blue.900"}>
            {" "}
            {priceUtilityValve}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarCaster) && "blue.900"}>
            {" "}
            {priceUtilityCaster}
          </Text>
          <Text fontSize="text3" color={validationValue(priceCarCamber) && "blue.900"}>
            {" "}
            {priceUtilityCamber}
          </Text>
          {runflat && (
            <Text fontSize="text3" color={validationValue(priceCarRunflat) && "blue.900"}>
              {" "}
              {priceUtilityRunflat}
            </Text>
          )}
          {blindado && (
            <Text fontSize="text3" color={validationValue(priceCarBlindado) && "blue.900"}>
              {" "}
              {priceUtilityBlindado}
            </Text>
          )}
        </Flex>
      </Flex>
    </Radio>
  );
}
